function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.553 392.553",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M370.098,355.077l-20.558-65.552c-1.552-4.913-6.077-8.339-11.378-8.339h-42.99v24.824 c0,18.036-14.675,32.711-32.711,32.711H130.065c-18.036,0-32.711-14.675-32.711-32.711v-24.76h-42.99 c-5.172,0-9.762,3.297-11.378,8.339l-20.493,65.616c-1.164,3.62-0.517,7.499,1.745,10.602c2.263,3.103,5.689,4.848,9.568,4.848 h324.978c3.814,0,7.37-1.745,9.568-4.848C370.615,362.576,371.197,358.762,370.098,355.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.14,32.621v273.455c0,6.012,4.848,10.925,10.925,10.925h132.461 c6.012,0,10.925-4.848,10.925-10.925V32.621c0-6.012-4.848-10.925-10.925-10.925H130.065C123.989,21.76,119.14,26.673,119.14,32.621 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M142.025,149.114V46.39c0-0.84,0.711-1.552,1.552-1.552h105.568c0.84,0,1.552,0.711,1.552,1.552 v102.723c0,0.84-0.711,1.552-1.552,1.552H143.512C142.671,150.665,142.025,149.954,142.025,149.114z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M370.356,283.255c-4.396-14.093-17.325-23.596-32.129-23.596h-43.055V32.815 c0-18.036-14.675-32.711-32.711-32.711H130.065c-18.036,0-32.711,14.675-32.711,32.711v226.844h-42.99 c-14.739,0-27.669,9.503-32.129,23.596L1.677,348.677c-7.499,22.691,11.378,43.766,32.129,43.766h324.978 c22.238,0.453,39.24-22.238,32.129-43.766L370.356,283.255z M119.14,32.815c0-6.012,4.848-10.925,10.925-10.925h132.461 c6.012,0,10.925,4.848,10.925,10.925v273.455c0,6.012-4.848,10.925-10.925,10.925H130.065c-6.012,0-10.925-4.848-10.925-10.925 C119.14,306.269,119.14,32.815,119.14,32.815z M358.785,370.722H33.742c-7.887,0.776-13.446-8.469-11.378-15.451l20.558-65.552 c1.552-4.913,6.077-8.339,11.378-8.339h43.055v24.824c0,18.036,14.675,32.711,32.711,32.711h132.461 c18.036,0,32.711-14.675,32.711-32.711V281.38h43.055c5.172,0,9.762,3.297,11.378,8.339l20.558,65.552 C371.972,361.994,368.288,370.463,358.785,370.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M170.082,174.649h-18.23c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h18.23c6.012,0,10.925-4.848,10.925-10.925C180.942,179.562,176.094,174.649,170.082,174.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M222.51,196.435h18.23c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.978-10.925-10.99-10.925 H222.51c-6.012,0-10.925,4.848-10.925,10.925C211.649,191.586,216.498,196.435,222.51,196.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M170.082,221.13h-18.23c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h18.23c6.012,0,10.925-4.848,10.925-10.925C180.942,225.978,176.094,221.13,170.082,221.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M240.675,221.13H222.51c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h18.23c6.012,0,10.925-4.848,10.925-10.925C251.601,225.978,246.752,221.13,240.675,221.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M170.082,267.546h-18.23c-6.012,0-10.925,4.848-10.925,10.925s4.848,10.925,10.925,10.925h18.23 c6.012,0,10.925-4.848,10.925-10.925C180.942,272.394,176.094,267.546,170.082,267.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M240.675,267.546H222.51c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h18.23c6.012,0,10.925-4.848,10.925-10.925C251.601,272.524,246.752,267.546,240.675,267.546z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/telephone-svgrepo-com.bcb57d3abfc332b28a84ddb93f356887.svg";
export { ForwardRef as ReactComponent };